// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiName: 'https://borracce-test.realaxiom.com',
  metApiName: 'https://test-api.realaxiom.com/v1',
  s3PublicBucket: 'com.elite.realvideo.test',
  imagesDomain: 'test-images.elitecustombottles.com',
  holidayJson: 'https://com-elite-borracce-test.s3.eu-west-1.amazonaws.com/holiday.json'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
